import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { toast } from 'sonner';
import { Plus, Pencil, Trash2, UserCheck } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AgentsList() {
  const token = localStorage.getItem('vendor_token');
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  const [agents, setAgents] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [editAgent, setEditAgent] = useState(null);
  const [form, setForm] = useState({ name: '', phone: '' });

  const fetchAgents = useCallback(async () => {
    const res = await fetch(`${API}/api/lis/agents`, { headers: { Authorization: `Bearer ${token}` } });
    setAgents(await res.json());
  }, [token]);
  useEffect(() => { fetchAgents(); }, [fetchAgents]);

  const openCreate = () => { setEditAgent(null); setForm({ name: '', phone: '' }); setShowDialog(true); };
  const openEdit = (a) => { setEditAgent(a); setForm({ name: a.name, phone: a.phone || '' }); setShowDialog(true); };
  const save = async () => {
    const url = editAgent ? `${API}/api/lis/agents/${editAgent.id}` : `${API}/api/lis/agents`;
    const res = await fetch(url, { method: editAgent ? 'PUT' : 'POST', headers, body: JSON.stringify(form) });
    if (res.ok) { toast.success(editAgent ? 'Updated' : 'Created'); setShowDialog(false); fetchAgents(); } else toast.error('Failed');
  };
  const deleteAgent = async (id) => { if (!window.confirm('Delete?')) return; await fetch(`${API}/api/lis/agents/${id}`, { method: 'DELETE', headers }); toast.success('Deleted'); fetchAgents(); };

  return (
    <div data-testid="lis-agents-list">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold text-slate-800">Sample Collection Agents</h1>
        <Button size="sm" onClick={openCreate} data-testid="add-agent-btn"><Plus className="w-3.5 h-3.5 mr-1" /> Add Agent</Button>
      </div>
      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {agents.map(a => (
          <Card key={a.id} className="border-slate-200"><CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div className="flex gap-3"><div className="w-9 h-9 rounded-lg bg-cyan-50 flex items-center justify-center shrink-0"><UserCheck className="w-4.5 h-4.5 text-cyan-600" /></div>
                <div><p className="font-medium text-slate-800">{a.name}</p>{a.phone && <p className="text-xs text-slate-500">{a.phone}</p>}</div></div>
              <div className="flex gap-1"><button onClick={() => openEdit(a)} className="p-1 text-slate-400 hover:text-blue-600"><Pencil className="w-3.5 h-3.5" /></button><button onClick={() => deleteAgent(a.id)} className="p-1 text-slate-400 hover:text-red-600"><Trash2 className="w-3.5 h-3.5" /></button></div>
            </div>
          </CardContent></Card>
        ))}
        {agents.length === 0 && <Card className="border-dashed border-slate-300 col-span-full"><CardContent className="p-8 text-center text-slate-400"><UserCheck className="w-8 h-8 mx-auto mb-2 opacity-50" /><p>No sample collection agents yet.</p></CardContent></Card>}
      </div>
      <Dialog open={showDialog} onOpenChange={setShowDialog}><DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle>{editAgent ? 'Edit Agent' : 'Add Agent'}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Input placeholder="Agent Name *" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} data-testid="agent-name-input" />
          <Input placeholder="Phone" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
        </div>
        <DialogFooter><Button variant="outline" onClick={() => setShowDialog(false)}>Cancel</Button><Button onClick={save} data-testid="save-agent-btn">{editAgent ? 'Update' : 'Create'}</Button></DialogFooter>
      </DialogContent></Dialog>
    </div>
  );
}
